import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { UserRole } from '../models/general.models';
import RouteAuthorizer from './components/RouteAuthorizer';
import { AppRoutes } from './routes';
var SearchResultPage = React.lazy(function () { return import('../pages/searchResult/searchResult.page'); });
var searchResultRedirectPages = [
    {
        userRole: UserRole.Anonymous,
        page: AppRoutes.Intro,
    },
    {
        userRole: UserRole.NoCountryUser,
        page: AppRoutes.Intro,
    },
    {
        userRole: UserRole.PartialUser,
        page: AppRoutes.JoinFamily,
    },
    {
        userRole: UserRole.PlanPendingUser,
        page: AppRoutes.OnboardingWelcomePage,
    },
    {
        userRole: UserRole.UserPaymentNeeded,
        page: AppRoutes.SubscriptionPage,
    },
];
var searchResultRoutes = [
    {
        path: AppRoutes.SearchResult,
        element: (_jsx(RouteAuthorizer, { userRoles: [UserRole.CompleteUser], redirectPages: searchResultRedirectPages, children: _jsx(SearchResultPage, {}) })),
    },
];
export default searchResultRoutes;
